if (!customElements.get('ab-pd2m-retired')) {
  customElements.define('ab-pd2m-retired', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.gallery = this.querySelector('.pmr-gallery');
      this.slides = [...this.querySelectorAll('.pmr-slide')];
      this.dots = [...this.querySelectorAll('.pmr-dots a')];
      if (!this.gallery || !this.dots.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dots.forEach((dot, index) => dot.addEventListener('click', event => {
        event.preventDefault();
        this.gallery.scrollTo({left:this.slides[index].offsetLeft - this.slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      }, options));
      this.gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.sync());
      }, {...options, passive:true});
      this.sync();
    }
    sync() {
      const frame = this.gallery.getBoundingClientRect();
      let active = 0, distance = Infinity;
      this.slides.forEach((slide,index) => {
        const delta = Math.abs(slide.getBoundingClientRect().left-frame.left);
        if (delta<distance) {distance=delta;active=index;}
      });
      this.dots.forEach((dot,index) => index===active?dot.setAttribute('aria-current','true'):dot.removeAttribute('aria-current'));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.scrollFrame);
      this.controller?.abort();
      this.controller = null;
    }
  });
}
